import React from 'react';
import { Button, Input, Upload, UploadFile, UploadProps } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { UploadChangeParam } from 'antd/es/upload';
import { setLoading } from '../../../redux/slice/appConfigSlice';
import { uploadFile } from '../../../service/fileUploadService';
import processError from '../../../utils/processError';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/store/store';

interface FileUploadProps extends Omit<UploadProps, 'onChange'> {
  url: string;
  setUrl: (url: string) => void;
  label?: string;
  placeholder?: string;
}

function FileUpload({ url, setUrl, label = 'Tải file', placeholder = 'Link file...', ...restProps }: FileUploadProps) {
  const dispatch = useDispatch<AppDispatch>();

  function handleFileChange(info: UploadChangeParam<UploadFile<any>>) {
    const formData = new FormData();
    if (!info.file) return;
    dispatch(setLoading(true));
    formData.append('file', info.file as any);
    uploadFile(formData)
      .then((data) => {
        if (data?.status === 1) {
          setUrl(data.url);
        }
      })
      .catch((error) => {
        processError(error);
      })
      .finally(() => dispatch(setLoading(false)));
  }

  return (
    <div className="flex items-center w-full">
      <Upload
        onChange={handleFileChange}
        className="w-auto"
        beforeUpload={() => false}
        maxCount={1}
        showUploadList={false}
        {...restProps}
      >
        <Button
          icon={<UploadOutlined />}
          className="rounded-none rounded-l-md bg-blue-500 text-white hover:bg-blue-600 border border-gray-300 border-r-0"
        >
          {label}
        </Button>
      </Upload>
      <Input value={url} placeholder={placeholder} className="rounded-l-none flex-1" readOnly={true} />
    </div>
  );
}

export default FileUpload;
